var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-page-work",attrs:{"id":"l-page-work"}},[_c('div',{staticClass:"l-content"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }